<template>
  <a-col
    @click="onClick"
    :class="`option-item-container ${noLabel && 'no-label'}  ${isLens && 'circle'} ${isSelected && 'selected'}`"
    :span="col === 2 ? 12 : 24"
  >
    <div class="boundary">
      <img class="img" alt="" v-if="!isLens" :src="thumbnail" />
      <div class="img" v-if="isLens" :style="`background-color: ${color};`" />
    </div>
    <span v-if="!noLabel">{{ item.sku }}</span>
  </a-col>
</template>

<script>
import { rgbToCSS } from "../../utils";

export default {
  props: ["item", "col"],
  methods: {
    onClick: function() {
      this.$emit("select-item", this.item);
    }
  },
  computed: {
    noLabel() {
      return ["rim", "temple"].includes(this.item.kind);
    },
    thumbnail() {
      if (this.item.kind === "style") {
        return window.GLASSON_CONFIG.STORAGE + this.item.texture;
      }
      return this.item.texture;
    },
    isSelected() {
      const { kind, sku, texture } = this.item;
      if (this.noLabel) {
        return this.$store.state.selectedOpt[kind].texture === texture;
      } else {
        return this.$store.state.selectedOpt[kind].sku === sku;
      }
    },
    isLens() {
      return this.item.kind === "lens";
    },
    color() {
      return rgbToCSS(this.item.colors.split(","));
    }
  }
};
</script>

<style lang="scss" scoped>
.option-item {
  &-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 84px;
    margin: 8px 0;
    cursor: pointer;

    &.no-label {
      height: 60px;
      margin: 4px 0;

      .img {
        object-fit: cover;
      }
    }

    .boundary {
      width: 100%;
      height: 60px;
      border: 1.5px solid transparent;
      border-radius: 4px;
    }

    &.selected .boundary {
      border-color: rgb(47, 128, 237);
    }

    &.circle {
      .boundary {
        width: 60px;
        border-width: 2.5px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
        }
      }
    }

    .img {
      object-fit: contain;
      width: 100%;
      height: 100%;
      padding: 6px;
    }

    span {
      color: #333333;
      font-size: 0.8rem;
    }
  }
}
</style>
